import React, { createContext, useCallback, useContext, useState } from 'react';
import { ValidateData, validateUser, RegisterUserData } from '../services/register';

interface RegisterContextData {
  userData: RegisterUserData;
  loading: boolean;
  step: string;
  handleLoading(loading: boolean): void;
  handleValidateLasaUser(data: ValidateData): void;
  handleData(newData: any): void;
  handleStep(step: string): void;
  clearData(): void;
}

const RegisterContext = createContext<RegisterContextData>({} as RegisterContextData);

const RegisterProvider: React.FC = ({ children }) => {
  const [userData, setUserData] = useState<RegisterUserData>({} as RegisterUserData);
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState('registerForm');

  const handleData = useCallback((newData) => {
    setUserData((oldState) => ({ ...oldState, ...newData }));
  }, []);

  const clearData = () => {
    setUserData({} as RegisterUserData);
  };

  const handleValidateLasaUser = useCallback(
    async (validateUserData) => {
      setLoading(true);

      try {
        const { data } = await validateUser(validateUserData);
        handleData({
          registrationNumber: validateUserData.registrationNumber,
          accessToken: data.access_token,
        });
        setStep('registerSuccess');
      } catch (e) {
        const { data, status } = e.response;
        if (status === 400 && data.error.message === 'Matrícula já cadastrada.') {
          setStep('alreadyRegistered');
        } else {
          setStep('registerError');
        }
      }

      setLoading(false);
    },
    [userData, setUserData],
  );

  return (
    <RegisterContext.Provider
      value={{
        userData,
        step,
        loading,
        handleLoading: setLoading,
        handleStep: setStep,
        handleValidateLasaUser,
        handleData,
        clearData,
      }}
    >
      {children}
    </RegisterContext.Provider>
  );
};

function useRegister(): RegisterContextData {
  const context = useContext(RegisterContext);

  if (!context) {
    throw new Error('useRegister must be used inside of RegisterProvider');
  }

  return context;
}

export { RegisterProvider, useRegister };
